import type { Recipe } from '../../types'
import { image, ingredient, scaled, section, peopleScaler } from '../helpers'

export const bainganBharta: Recipe = {
  slug: 'baingan-bharta',
  title: 'Baingan bharta',
  category: 'salé',
  description: 'Version douce, pas trop épicée, pour environ 2 personnes.',
  image: image('baingan-bharta'),
  tags: ['aubergine', 'air fryer', 'doux'],
  scaler: peopleScaler(2),
  meta: [
    { label: 'Préparation', value: '15 min' },
    { label: 'Cuisson aubergines', value: 'air fryer 200 °C, 12 à 18 min' },
    { label: 'Cuisson sauce', value: '10 à 15 min' },
  ],
  sections: [
    section('Base', [
      scaled('aubergine', 'aubergine', 1, 'grosse aubergine', {
        pluralUnit: 'grosses aubergines',
        shoppingKey: 'aubergine',
      }),
      scaled('oignon', 'oignon', 1, 'petit oignon (80 g)', {
        pluralUnit: 'petits oignons (80 g chacun)',
        shoppingKey: 'oignon',
      }),
      scaled('tomate', 'tomate mûre', 1, 'tomate mûre (120 g)', {
        pluralUnit: 'tomates mûres (120 g chacune)',
        shoppingKey: 'tomate',
      }),
      scaled('coulis', 'coulis de tomate', 100, 'g', {
        display: '100 g de coulis de tomate',
        shoppingKey: 'coulis de tomate',
      }),
      scaled('gingembre', 'gingembre frais', 6, 'g', { display: '6 g de gingembre frais' }),
      scaled('huile', 'huile', 15, 'g', { display: '15 g (≈ 1 c. à soupe) d’huile' }),
      scaled('sel', 'sel fin', 3, 'g', {
        display: '3 g (≈ 1/2 c. à café rase) de sel fin',
      }),
    ]),
    section('Épices', [
      scaled('cumin', 'cumin moulu', 1.5, 'g', {
        display: '1,5 g (≈ 3/4 c. à café rase) de cumin moulu',
      }),
      scaled('curcuma', 'curcuma', 0.6, 'g', {
        display: '0,6 g (≈ 1/4 c. à café rase) de curcuma',
      }),
      scaled('paprika', 'paprika doux', 1.2, 'g', {
        display: '1,2 g (≈ 1/2 c. à café rase) de paprika doux',
      }),
    ]),
    section('Options', [
      scaled('ail', 'ail', 1, 'petite gousse d’ail', {
        pluralUnit: 'petites gousses d’ail',
        optional: true,
        shoppingKey: 'ail',
      }),
      scaled('yaourt', 'yaourt nature ou crème', 20, 'g', {
        display: '20 g (≈ 1 c. à soupe) de yaourt nature ou de crème',
        optional: true,
      }),
      ingredient('piment', 'piment vert', 'Pas de piment vert pour garder une version douce.', {
        optional: true,
      }),
    ]),
  ],
  steps: [
    'Couper l’aubergine en deux dans la longueur. Quadriller légèrement la chair, badigeonner d’un peu d’huile, puis cuire à l’air fryer à 200 °C pendant 12 à 18 minutes. Commencer à vérifier dès 10 minutes : la chair doit être très fondante et légèrement dorée.',
    'Laisser tiédir, récupérer la chair à la cuillère puis l’écraser grossièrement à la fourchette. C’est cette aubergine bien grillée qui apporte le goût typique du baingan bharta.',
    'Dans une poêle, faire revenir l’oignon très finement émincé dans le reste d’huile pendant 5 à 6 minutes à feu moyen, jusqu’à ce qu’il devienne tendre et commence à fondre.',
    'Ajouter le gingembre, puis l’ail si vous en mettez, et cuire 30 secondes. Ajouter ensuite le cumin, le curcuma et le paprika doux, puis cuire encore 20 secondes pour réveiller les épices.',
    'Ajouter la tomate en dés et cuire 5 minutes, jusqu’à obtenir une base un peu compotée. Pour une texture plus lisse, remplacer la tomate par le coulis.',
    'Ajouter l’aubergine écrasée, mélanger soigneusement, puis laisser compoter 5 à 8 minutes. Ajuster le sel et ajouter une cuillère d’eau si la texture devient trop épaisse.',
    'Pour une version encore plus douce, couper le feu puis incorporer le yaourt ou la crème juste avant de servir.',
  ],
  note: 'Les grammes sont la référence. Les équivalences en cuillères servent surtout à aller plus vite.',
}
